<!--経費詳細画面-->
<template>
  <div>
    <div class="all_area_k0007">
      <!--検索エイア-->
      <div class="search-module_k0007">
        <el-row>
          <el-col :span="4" class="el-col_k0007">
            <div class="grid-content bg-purple c0007_readonly_input">
              <span class="span_search_condition_k0007 ">{{$t('MODULE.K0002_LBL_CORPORATION_NAME')}}</span>
              <!--企業-->
              <el-input class=" css-input-width_k0007 " style="margin-top: 8px ;margin-left: 10px" size="small" v-model="company_name" :disabled="true"></el-input>
            </div>
          </el-col>
          <el-col :span="5" class="el-col_k0007">
            <div class="grid-content bg-purple c0007_readonly_input">
              <span class="span_search_condition_k0007" size="small">{{$t('MODULE.K0007_LBL_FIELDNAME')}}</span>
              <!--現場-->
              <el-input class="css-input-width_k0007" style="margin-top: 8px ;margin-left: 10px" size="small" v-model="fieldName" :disabled="true"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="el-col_k0007">
            <div class="grid-content bg-purple c0007_readonly_input">
              <span class="span_search_condition_k0007">{{$t('COMMON.LBL_WORKDAY')}}</span>
              <!--作業日-->
              <el-input class="css-input-width_k0007 " style="margin-top: 8px; margin-left: 10px" size="small" v-model="job_date" :disabled="true"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--入力エイア-->
      <div class="el-detail_k0007">
        <el-row>
          <div class="div_span_k0007_trasport">
            <!--交通費自動計算-->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRANSPORTEXPENSE_AUTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007_trasport">
            <!--移動手段検索条件-->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRANSPORTFLAG')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_radio_k0007_trasport">
            <!-- なし-->
            <el-radio  @input="transportFlagChange" v-model="transportFlag" :disabled="status1" label="4">{{$t('MODULE.K0007_LBL_TRANSPORTFLAG_NO')}}</el-radio>
            <!--マイカー-->
            <el-radio  @input="transportFlagChange" v-model="transportFlag" :disabled="status1" label="2">{{$t('MODULE.K0007_LBL_TRANSPORTFLAG_MYCAR')}}</el-radio>
            <!--電車・バス-->
            <el-radio  @input="transportFlagChange" v-model="transportFlag" :disabled="status1" label="1">{{$t('MODULE.K0007_LBL_TRANSPORTFLAG_BUS')}}</el-radio>
          </div>
        </el-row>
        <el-row>
          <div class="div_radio_k0007_trasport">
            <!-- 作業終了後帰宅-->
            <el-radio  v-model="otherFieldFlag" :disabled="status1||disableTransportFlag()" label="0">{{$t('MODULE.K0007_LBL_OTHERFIELDFLAG_OK')}}</el-radio>
            <!--帰宅せず別現場へ-->
            <el-radio  v-model="otherFieldFlag" :disabled="status1||disableTransportFlag()" label="1">{{$t('MODULE.K0007_LBL_OTHERFIELDFLAG_NO')}}</el-radio>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007">
            <!-- 別現場より移動-->
            <el-checkbox  class="input_input1_k0007_trasport " @change="initiallyFieldChange"  :disabled="status1||disableTransportFlag()"  v-model="initiallyFieldFlag" true-label="1" false-label="0">{{$t('MODULE.K0007_LBL_INITIALLYFIELDFLAG')}}</el-checkbox>
            <!-- 現場名 -->
            <el-select class="input_input1_k0007 textRight" popper-class="selectStyle" v-model="initiallyFieldCd" :disabled="initiallyFieldFlag==0||status1||disableTransportFlag()" @change="fieldListChange(initiallyFieldCd,'initiallyFieldCd')"  :placeholder=" $t('COMMON.PLACEHOLDER_SELECT')" filterable>
              <el-option v-for="item in initiallyFieldList" :key="item.fieldCd" :label="item.fieldName" :value="item.fieldCd">
              </el-option>
            </el-select>
          </div>
        </el-row>
        <el-row style="text-align:center;">
          <div class="div_span_k0007_trasport" style="height:50px;padding-top:6px">
            <!--検索(交通費自動計算)-->
            <el-button class="css-btn_green css-button_green" type="primary" @click="transport_search_click" :disabled="status1||disableTransportFlag()">{{$t('COMMON.LBL_SEARCH')}}</el-button>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007_trasport">
            <!-- 電車・バス（自動） -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRAINBUS')}}</span>
            <!--移動km（自動）-->
            <span class="input_span2_k0007" style="padding:3px 0px 0px 20px;">{{$t('MODULE.K0002_LBL_CATEGORY_EXPENSE')}}</span>
            <!--ｶﾞｿﾘﾝ精算（自動）-->
            <span class="input_span2_k0007" style="padding:3px 0px 0px 5px;">{{$t('MODULE.K0002_LBL_GAS_EXPENSE')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:true}">
            <el-input class="input_input1_k0007 textRight " :class=" {K0007_disable_input:true}" v-model="trainBusAuto" :disabled="true" ></el-input>
            <el-input class="input_input2_k0007 textRight" style="padding:10px 0px 0px 20px;" v-model="kmAuto"  :disabled="true"></el-input>
            <el-input class="input_input3_k0007 textRight " :class=" {K0007_disable_input:true}" style="padding:10px 0px 0px 5px;" v-model="kmPriceAuto" :disabled="true"></el-input>
          </div>
        </el-row>
        <!-- 経路詳細 -->
        <el-row>
          <div class="div_collapse_k0007_trasport">
            <el-collapse v-model="activeCollapseName" accordion>
              <el-collapse-item name="1">
                <template slot="title">{{$t('MODULE.K0007_LBL_ROUTE')}}</template>                
                <span class="multiline">{{route}}</span>                
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-row> 
        <el-row>
          <div class="div_span_k0007">
            <!--交通費直接入力-->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRANSPORTEXPENSE_MANUAL')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 電車・バス -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRAINBUS')}}</span>
            <!--移動km-->
            <span class="input_span2_k0007" style="padding:3px 0px 0px 20px;">{{$t('MODULE.K0002_LBL_CATEGORY_EXPENSE')}}</span>
            <!--ｶﾞｿﾘﾝ精算-->
            <span class="input_span2_k0007" style="padding:3px 0px 0px 5px;">{{$t('MODULE.K0002_LBL_GAS_EXPENSE')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <el-input class="input_input1_k0007 textRight " v-model="trainBus" maxlength="8" pattern="\d*" :disabled="status1" @focus="focusInput(trainBus,'trainBus')" @input="inputChange()" @blur="blurInput(trainBus,'trainBus',$t('MODULE.K0007_LBL_TRAINBUS'))"></el-input>
            <el-input class="input_input2_k0007 textRight" style="padding:10px 0px 0px 20px;" v-model="km" maxlength="8" :disabled="status1" @focus="focusInput(km,'km')" @input="inputChange()" @blur="blurInput(km,'km',$t('MODULE.K0007_LBL_KMPRICE'))"></el-input>
            <el-input class="input_input3_k0007 textRight " :class=" {K0007_disable_input:true}" style="padding:10px 0px 0px 5px;" v-model="kmPrice" :disabled="true"></el-input>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007 ">
            <!-- 駐車代 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_PARKINGFEE')}}</span>
            <!-- 領収書写真 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_RECEIPTPHOTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 駐車代 -->
            <el-input class="input_input1_k0007 textRight" ref="parkingFee" v-model="parkingFee" maxlength="8" pattern="\d*" :disabled="status1" @focus="focusInput(parkingFee,'parkingFee')" @input="inputChange()" @blur="blurInput(parkingFee,'parkingFee',$t('MODULE.K0007_LBL_PARKINGFEE'))"></el-input>
            <!-- 領収書写真 -->
            <!-- <div > -->
            <div class="k0007-photo-border" :class="{'parkingFeeCss': parkingFeeCss}" v-if="!parkingFeeUrl"></div>
            <el-upload class="photo_upload" ref="parkingFee" :show-file-list="true" :file-list="parkingFeeImageList" :disabled="parkingFeeBtn" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'parkingFee','1')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img id="parkingFeeImg" class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'parkingFee')">
                  <span v-if="parkingFeeLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'parkingFee','1')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer v-if="parkingFeeDialog" :on-close="parkingFeePhotoDelete" :url-list="[parkingFeeUrl]" />
            <!-- </div> -->
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 有料道路代 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_ROADFEE')}}</span>
            <!-- 領収書写真 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_RECEIPTPHOTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 有料道路代 -->
            <el-input class="input_input1_k0007 textRight" v-model="roadFee" maxlength="8" pattern="\d*" :disabled="status1" @focus="focusInput(roadFee,'roadFee')" @input="inputChange()" @blur="blurInput(roadFee,'roadFee',$t('MODULE.K0007_LBL_ROADFEE'))"></el-input>
            <!-- 領収書写真 -->
            <div class="k0007-photo-border" :class="{'roadFeeCss': roadFeeCss}" v-if="!roadFeeUrl"></div>
            <el-upload class="photo_upload" ref="roadFee" :show-file-list="true" :file-list="roadFeeImageList" :disabled="roadFeeBtn" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'roadFee','2')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'roadFee')">
                  <span v-if="roadFeeLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'roadFee','2')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer v-if="roadFeeDialog" :on-close="roadFeePhotoDelete" :url-list="[roadFeeUrl]" />
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 移動手当 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_MOVEALLOWANCE')}}</span>
            <!-- 移動運転手当 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_DRIVERALLOWANCE')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 移動手当 -->
            <el-select class="input_input1_k0007 textRight" popper-class="selectStyle" v-model="moveAllowance" :disabled="status1" @change="expensesChange(moveAllowance,'moveAllowance',$t('MODULE.K0007_LBL_MOVEALLOWANCE'))" @blur="calculateExpenses()" :placeholder=" $t('COMMON.PLACEHOLDER_SELECT')">
              <el-option v-for="item in moveAllowanceList" :key="item.key" :label="item.value" :value="item.value">
                <span style="float: left">{{ item.note }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="float: right; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>
            <!-- 移動運転手当 -->
            <el-select class="input_input1_k0007 textRight" popper-class="selectStyle" v-model="driverAllowance" maxlength="8" :disabled="true" @change="expensesChange(driverAllowance,'driverAllowance',$t('MODULE.K0007_LBL_DRIVERALLOWANCE'))" @blur="calculateExpenses()" :placeholder=" $t('COMMON.PLACEHOLDER_SELECT')" ref="input">
              <el-option v-for="item in driverAllowanceList" :key="item.key" :label="item.value" :value="item.value">
                <span style="float: left">{{ item.note }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="float: right; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 消耗・通信・破損・運搬 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_OTHERSEXPENSES')}}</span>
            <!--  領収書写真 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_RECEIPTPHOTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 消耗・通信・破損・運搬 -->
            <el-input class="input_input1_k0007 textRight" v-model="othersExpenses" maxlength="8" pattern="\d*" :disabled="status1" @focus="focusInput(othersExpenses,'othersExpenses')" @input="inputChange()" @blur="blurInput(othersExpenses,'othersExpenses',$t('MODULE.K0007_LBL_OTHERSEXPENSES'))"></el-input>
            <!-- 領収書写真 -->
            <div class="k0007-photo-border" :class="{'othersExpensesCss': othersExpensesCss}" v-if="!othersExpensesUrl"></div>
            <el-upload class="photo_upload" ref="othersExpenses" :show-file-list="true" :file-list="othersExpensesImageList" :disabled="othersExpensesBtn" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'othersExpenses','3')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'othersExpenses')">
                  <span v-if="othersExpensesLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'othersExpenses','3')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer v-if="othersExpensesDialog" :on-close="othersExpensesPhotoDelete" :url-list="[othersExpensesUrl]" />
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 公共移動(出張) -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP')}}</span>
            <!-- 領収書写真 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_RECEIPTPHOTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 公共移動(出張) -->
            <el-input class="input_input1_k0007 textRight" id="transportExpensesTrip" v-model="transportExpensesTrip" maxlength="8" pattern="\d*" :disabled="status1" @input="inputChange()" @focus="focusInput(transportExpensesTrip,'transportExpensesTrip')" @blur="blurInput(transportExpensesTrip,'transportExpensesTrip',$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP'))"></el-input>
            <!-- 領収書写真 -->
            <div class="k0007-photo-border" :class="{'transportExpensesTripCss': transportExpensesTripCss}" v-if="!transportExpensesTripUrl"></div>
            <el-upload class="photo_upload" ref="transportExpensesTrip" :show-file-list="true" :file-list="transportExpensesTripImageList" :disabled="transportExpensesTripBtn" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'transportExpensesTrip','4')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'transportExpensesTrip')">
                  <span v-if="transportExpensesTripLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'transportExpensesTrip','4')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer v-if="transportExpensesTripDialog" :on-close="transportExpensesTripPhotoDelete" :url-list="[transportExpensesTripUrl]" />
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 宿泊費 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_ACCOMMODATION')}}</span>
            <!-- 領収書写真 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_RECEIPTPHOTO')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 " :class=" {K0007_disable_input:status1}">
            <!-- 宿泊費 -->
            <el-input class="input_input1_k0007 textRight" id="accommodation" v-model="accommodation" maxlength="8" pattern="\d*" :disabled="status1" @focus="focusInput(accommodation,'accommodation')" @blur="blurInput(accommodation,'accommodation',$t('MODULE.K0007_LBL_ACCOMMODATION'))"></el-input>
            <!-- 領収書写真 -->
            <div class="k0007-photo-border" :class="{'accommodationCss': accommodationCss}" v-if="!accommodationUrl"></div>
            <el-upload class="photo_upload" ref="accommodation" :show-file-list="true" :file-list="accommodationImageList" :disabled="accommodationBtn" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="string" :on-change="(file, fileList) => {handleChange(file, fileList,'accommodation','5')}" :auto-upload="false" multiple>
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <template slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file,'accommodation')">
                  <span v-if="accommodationLongClick" class="el-upload-list__item-delete" @click="(file, fileList) => {fileRemove(file, fileList,'accommodation','5')}">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </template>
            </el-upload>
            <!--图片预览用dialog-->
            <el-image-viewer v-if="accommodationDialog" :on-close="accommodationPhotoDelete" :url-list="[accommodationUrl]" />
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0007">
            <!-- 食事補助 -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_ALLOWANCETRIP')}}</span>
            <!-- 出張手当(管理職以上) -->
            <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TRIPALLOWANCEMANAGER')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0007 ">
            <!-- 食事補助 -->
            <el-select class="input_input1_k0007 textRight" :class=" {K0007_disable_input:status1}" id="allowanceTrip" v-model="allowanceTrip" :disabled="status1" popper-class="selectStyle" @change="expensesChange(allowanceTrip,'allowanceTrip',$t('MODULE.K0007_LBL_ALLOWANCETRIP'))" @blur="calculateExpenses()" :placeholder="$t('COMMON.PLACEHOLDER_SELECT')">
              <el-option v-for="item in allowanceTripList" :key="item.key" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
            <!-- 出張手当(管理職以上) -->
            <el-select class="input_input1_k0007 textRight" :class=" {K0007_disable_input:status1}" id="tripAllowanceManager" v-model="tripAllowanceManager" :disabled="tripAllowanceStatus" popper-class="selectStyle" @change="expensesChange(tripAllowanceManager,'tripAllowanceManager',$t('MODULE.k0007_LBL_TRIPALLOWANCEMANAGER'))" @blur="calculateExpenses()" :placeholder="$t('COMMON.PLACEHOLDER_SELECT')">
              <el-option v-for="item in tripAllowanceManagerList" :key="item.key" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="12">
            <div class="div_span_k0007_total">
              <!-- 実費計 -->
              <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL')}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <!-- 合計 -->
            <div class="div_span_k0007_total">
              <span class="input_span_k0007">{{$t('MODULE.K0007_LBL_TOTAL')}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="2">
          <el-col :span="12">
            <div class="div_input_k0007 ">
              <!-- 実費計 -->
              <el-input class="input_input1_k0007_total textRight" id="actualCostTotal" v-model="actualCostTotal" :disabled="true"></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="div_input_k0007 ">
              <!-- 合計 -->
              <el-input class="input_input1_k0007_total textRight" id="total" v-model="total" :disabled="true"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--保存-->
      <div>
        <el-row style="text-align:center;">
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="save_click" v-show="!(status2)">{{$t('COMMON.BTN_SAVE')}}</el-button>
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as amsApi from "../api/k_0007"
let url = require('@/../config/sysConfig')
import validatorApi from '../../common/validator'
import utilsApi from '../../common/utils'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import utils from '../../common/utils'
import encoding from 'encoding-japanese';
// import { Switch } from 'element-ui'
import css from "@/statics/css"
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      inputFlag: false,
      obj: [],
      gamenId: 'SK_0007',
      approvalStatus: '1',//勤怠承認「1：承認」
      userInfo: [],
      checked: true,
      fileList: [],//放大图片
      approvalFlag: '',//勤怠承認FLAG
      cl: '',
      listLoading: false,
      queryParam: [],
      job_date: '',
      company_name: '',
      fieldName: '',
      jobState: '',
      crewCd: '',
      userCd: '',
      teamCd: '',
      trainBus: '',//電車・バス
      km: '',//移動km
      kmPrice: '',//ｶﾞｿﾘﾝ精算
      trainBusAuto: '',//電車・バス(自動)
      kmAuto: '',//移動km(自動)
      kmPriceAuto: '',//ｶﾞｿﾘﾝ精算(自動)
      parkingFee: '',//駐車代
      roadFee: '',//有料道路代
      moveAllowance: '',//移動手当
      driverAllowance: '',//移動・移動運転手当
      othersExpenses: '',//消耗・通信・破損・運搬
      transportExpensesTrip: '',//公共移動(出張)
      accommodation: '',//宿泊費
      allowanceTrip: '',//食事補助
      tripAllowanceManager: '',//出張手当(管理職以上)
      actualCostTotal: '',//実費計
      total: '',//合計
      parkingFeeImage: '',//駐車代图片
      roadFeeImage: '',//有料道路代图片
      othersExpensesImage: '',//消耗・通信・破損・運搬图片
      transportExpensesTripImage: '',//公共移動(出張)图片
      accommodationImage: '',//宿泊費图片
      allowanceTripList: [],//食事補助
      driverAllowanceList: [],//移動運転手当
      moveAllowanceList: [],//移動手当List
      personalAttendanceExpense: [],//経費チェック
      tripAllowanceManagerList: [],//出張手当(管理職以上)
      parkingFeeBtn: true,//駐車代上传按钮制御
      roadFeeBtn: true,//有料道路代上传按钮制御
      othersExpensesBtn: true,//消耗・通信・破損・運搬图片上传按钮制御
      transportExpensesTripBtn: true,//公共移動(出張)图片上传按钮制御
      accommodationBtn: true,//宿泊費图片上传按钮制御
      parkingFeeCss: true,//駐車代图片边框样式
      roadFeeCss: true,//有料道路代图片边框样式
      othersExpensesCss: true,//消耗・通信・破損・運搬图片边框样式
      transportExpensesTripCss: true,//公共移動(出張)图片边框样式
      accommodationCss: true,//宿泊費图片边框样式
      parkingFeeUrl: '',//駐車代图片边框样式
      roadFeeUrl: '',//有料道路代图片边框样式
      othersExpensesUrl: '',//消耗・通信・破損・運搬图片边框样式
      transportExpensesTripUrl: '',//公共移動(出張)图片边框样式
      accommodationUrl: '',//宿泊費图片边框样式
      parkingFeeDialog: false,
      roadFeeDialog: false,
      othersExpensesDialog: false,
      transportExpensesTripDialog: false,
      accommodationDialog: false,
      parkingFeeLongClick: false,//是否为图片长按模式（true=长按模式）。
      roadFeeLongClick: false,//是否为图片长按模式（true=长按模式）。
      othersExpensesLongClick: false,//是否为图片长按模式（true=长按模式）。
      transportExpensesTripLongClick: false,//是否为图片长按模式（true=长按模式）。
      accommodationLongClick: false,//是否为图片长按模式（true=长按模式）。
      photoFormData: {},
      transportTeate: '',
      updateDate: '',
      initFlg: 0,
      changeFgl: false,
      transmitFlag: '',
      imageSelect: false,
      photoImage: '',//照相图片
      parkingFeeImageList: [],
      roadFeeImageList: [],
      othersExpensesImageList: [],
      transportExpensesTripImageList: [],
      accommodationImageList: [],
      photoListInit: {},
      photoList: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      photoItem: { 1: {}, 2: {}, 3: {}, 4: {}, 5: {} },
      personalPhotoData: [],
      srcindex: 0,//图片检索成功数
      params: {
        siteId: '' //サイトid
      },
      status1: false,
      status2: false,
      tripAllowanceStatus: false,//出張手当(管理職以上)权限
      transportFlag:'',//移動手段(1:電車・バス 	2:マイカー 	4:なし	3:直接入力	)
      route:'',//経路
      otherFieldFlag:'',     //別店舗移動チェック 
      initiallyFieldFlag:'0', //別店舗移動元現場チェック 
      initiallyFieldCd:'',   //別店舗移動元現場cd    
      initiallyFieldName:'',   //別店舗移動元現場Name   
      initiallyFieldList:[],   //別店舗移動元現場list 
      initiallyFieldGeoLocationLatS:'',//別店舗緯度(店) 
      initiallyFieldGeoLocationLngS:'',//別店舗経度(店)
      initiallyFieldNearestStationS:'',//別店舗最寄り駅(店) 
      initiallyFieldNearestStationBusS:'',//別店舗最寄りバス停(店) 
      geoLocationLatP:'',    //緯度(人)      
      geoLocationLngP:'',    //経度(人)      
      nearestStationP:'',    //最寄り駅(人)    
      nearestStationBusP:'', //最寄りバス停(人) 
      geoLocationLatS:'',    //緯度(店)      
      geoLocationLngS:'',    //経度(店)      
      nearestStationS:'',    //最寄り駅(店)    
      nearestStationBusS:'', //最寄りバス停(店) 
      activeCollapseName:'',//経路詳細折叠面板激活
      transport_status_copy:{},//自动计算交通费的初始状态保存
    }
  },
  methods: {
    // 画像文件之前的钩子
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
        return
      }

      this[itemName + 'LongClick'] = false
      if (file.status === "ready") {
        // 已上传文件列表如果存在 2 条记录，移除第一条，实现替换效果
        if (fileList.length === 2) {
          fileList.shift();
        }
      }
      this[itemName + 'Url'] = file.url
      var that = this
      this.getBase64(file.raw).then(async res => {
        // 进行图片压缩获取压缩后的blob文件
        var photo = await that.compressImg(that.base64ToBlob(res))
        let files = new window.File([photo], file.name, { type: file.type })
        // image/personalPhoto/クルーコード/社員ID_店舗役職CD_種別_写真ID_yyyyMMddHHmmssSSS.拡張子
        let photoPath = 'image/personalPhoto/' + that.crewCd + '/' + that.userCd + '_' + that.storePositionCd + '_' + type + '_' + '0_' + utils.timeNumberGet() + '.' + file.name.split('.').pop()
        this.photoList[type] = {}
        this.photoList[type].itemName = itemName
        this.photoList[type].files = files
        this.photoList[type].photoId = '0'
        this.photoList[type].photoPath = photoPath
        this.photoList[type].type = type
        if (this[itemName + 'ImageList'].length > 0) {
          this.photoGet(itemName, file.url, this.photoList[type])
        }
      })
    },

    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },

    // 压缩图片
    compressImg(file) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },

    //单张图片删除
    fileRemove(file, fileList, itemName, type) {
      this.$refs[itemName].clearFiles()
      this[itemName + "Url"] = ''
      this[itemName + "LongClick"] = false
      this.photoList[type] = ''
    },
    //单张图片点击
    handlePictureCardPreview(file, dialogName) {
      if (this[dialogName + 'LongClick'] == true) {
        this[dialogName + 'LongClick'] = false
      } else {
        this[dialogName + 'Url'] = file.url;
        this[dialogName + 'Dialog'] = true;
      }
    },
    // 検索
    query() {
      console.log('query')
      var Params = {
        'crewCd': this.crewCd,
        'jobState': this.jobState,
        'storePositionCd': this.storePositionCd,
        'userId': this.userInfo.userCd,
        'status': '2',
        'trminal': 'staff'
      }

      //实现Loading 加载方法
      this.set_loading()

      // 検索処理
      amsApi.k_0007(Params).then(res => {
        console.log(res)
        // this.job_date = res.items[0].jobDate
        this.company_name = res.items[0].companyName
        this.fieldName = res.items[0].fieldName
        // this.userCd = res.items[0].userCd
        this.storePositionCd = res.items[0].storePositionCd
        this.teamCd = res.items[0].teamCd
        this.transportFlag=res.items[0].transportFlag 
        console.log('this.transportFlag:'+this.transportFlag)
        if(this.transportFlag=='3'||this.transportFlag=='4'){
          this.trainBus = res.items[0].trainBus == null || res.items[0].trainBus === '' ? '0' : utilsApi.decimalFormatter(res.items[0].trainBus.toString())
          this.km = res.items[0].km == null || res.items[0].km === '' ? '0.0' : utilsApi.decimalFormatter(utilsApi.tofixeds(res.items[0].km, 1).toString())
          this.kmPrice = res.items[0].kmPrice == null || res.items[0].kmPrice === '' ? '0' : utilsApi.decimalFormatter(res.items[0].kmPrice.toString())
          this.trainBusAuto='0'
          this.kmAuto='0.0'
          this.kmPriceAuto='0'
        }else if(this.transportFlag=='2'){
          this.kmAuto = res.items[0].km == null || res.items[0].km === '' ? '0.0' : utilsApi.decimalFormatter(utilsApi.tofixeds(res.items[0].km, 1).toString())
          this.kmPriceAuto = res.items[0].kmPrice == null || res.items[0].kmPrice === '' ? '0' : utilsApi.decimalFormatter(res.items[0].kmPrice.toString())
          this.trainBusAuto='0'
          this.trainBus='0'
          this.km='0.0'
          this.kmPrice='0'
        }else if(this.transportFlag=='1'){
          this.trainBusAuto = res.items[0].trainBus == null || res.items[0].trainBus === '' ? '0' : utilsApi.decimalFormatter(res.items[0].trainBus.toString())
          this.kmAuto='0.0'
          this.kmPriceAuto ='0'
          this.trainBus='0'
          this.km='0.0'
          this.kmPrice='0'
        }   
        this.parkingFee = res.items[0].parkingFee == null || res.items[0].parkingFee === '' ? '0' : utilsApi.decimalFormatter(res.items[0].parkingFee.toString())
        this.roadFee = res.items[0].roadFee == null || res.items[0].roadFee === '' ? '0' : utilsApi.decimalFormatter(res.items[0].roadFee.toString())
        this.moveAllowance = res.items[0].moveAllowance == null || res.items[0].moveAllowance === '' ? '0' : utilsApi.decimalFormatter(res.items[0].moveAllowance.toString())
        this.driverAllowance = res.items[0].driverAllowance == null || res.items[0].driverAllowance === '' ? '0' : utilsApi.decimalFormatter(res.items[0].driverAllowance.toString())
        this.othersExpenses = res.items[0].othersExpenses == null || res.items[0].othersExpenses === '' ? '0' : utilsApi.decimalFormatter(res.items[0].othersExpenses.toString())
        this.transportExpensesTrip = res.items[0].transportExpensesTrip == null || res.items[0].transportExpensesTrip === '' ? '0' : utilsApi.decimalFormatter(res.items[0].transportExpensesTrip.toString())
        this.accommodation = res.items[0].accommodation == null || res.items[0].accommodation === '' ? '0' : utilsApi.decimalFormatter(res.items[0].accommodation.toString())
        this.allowanceTrip = res.items[0].allowanceTrip == null || res.items[0].allowanceTrip === '' ? '0' : utilsApi.decimalFormatter(res.items[0].allowanceTrip.toString())
        this.tripAllowanceManager = res.items[0].tripAllowanceManager == null || res.items[0].tripAllowanceManager === '' ? '0' : utilsApi.decimalFormatter(res.items[0].tripAllowanceManager.toString())
        this.actualCostTotal = res.items[0].actualCostTotal == null || res.items[0].actualCostTotal === '' ? '0' : utilsApi.decimalFormatter(res.items[0].actualCostTotal.toString())
        this.total = res.items[0].total == null || res.items[0].total === '' ? '0' : utilsApi.decimalFormatter(res.items[0].total.toString())
        this.transportTeate = res.items[0].transportTeate
        this.updateDate = res.items[0].updateDate
        
        this.route=res.items[0].route
        this.otherFieldFlag=res.items[0].otherFieldFlag
        this.initiallyFieldFlag=res.items[0].initiallyFieldFlag
        this.initiallyFieldCd=res.items[0].initiallyFieldCd
        this.geoLocationLatP=res.items[0].geoLocationLatP
        this.geoLocationLngP=res.items[0].geoLocationLngP
        this.nearestStationP=res.items[0].nearestStationP
        this.nearestStationBusP=res.items[0].nearestStationBusP
        this.geoLocationLatS=res.items[0].geoLocationLatS
        this.geoLocationLngS=res.items[0].geoLocationLngS
        this.nearestStationS=res.items[0].nearestStationS
        this.nearestStationBusS=res.items[0].nearestStationBusS
        //自动计算交通费的初始状态保存(只保存时check使用)
        this.transport_status_copy.otherFieldFlag=this.otherFieldFlag
        this.transport_status_copy.initiallyFieldFlag=this.initiallyFieldFlag
        this.transport_status_copy.transportFlag=this.transportFlag
        this.transport_status_copy.initiallyFieldCd=this.initiallyFieldCd

        this.status1 = true;
        this.status2 = true;
        //0005182: スタッフ側：勤怠詳細画面経費項目制御変更
        if (this.jobState == '1') {
          //作業中の場合 1
          this.status1 = false;
          this.status2 = false;
        }
        //作業中以外の場合 2
        //作業完了、且つ連携フラグ=0、且つ現在日時<=作業日+1・の場合
        if (this.jobState == '2' && this.compareDate(this.job_date) && this.transmitFlag == 0) {
          this.status1 = false;
          this.status2 = false;
        }

        // 出張手当(管理職以上)の制御について、登録者のIDは09690000～09699999の場合、活性にする。以外の場合、非活性にする。
        if (Number(this.userCd) >= Number("09690000") && Number(this.userCd) <= Number("09699999")) {
          this.tripAllowanceStatus = false
        } else {
          this.tripAllowanceStatus = true
        }

        //上記以外の場合
        if (this.transmitFlag == 1) {
          this.tripAllowanceStatus = true;
        }
        //経路詳細折叠面板激活
        // if(this.isEmpty(this.route)){
        //   this.activeCollapseName='1'
        // }else{
        //   this.activeCollapseName='0'
        // }
        this.searchStoreFieldInfo()
        this.photoInfoGet()
      }).catch((error) => {
        this.close_loading();
      })
    },

    // 写真情報取得
    photoInfoGet() {
      var params = {
        crewCd: this.crewCd,
        userId: this.userInfo.userCd,
        storePositionCd: this.storePositionCd,
        type: '1,2,3,4,5',
      }
      // 清空原照片数据，取最新数据
      this.photoInit()
      amsApi.photoInfo(params).then(res => {
        if (res.code == 204) {
          this.personalPhotoData = res.items.personalPhotoData
          this.srcindex = 0
          for (var item of this.personalPhotoData) {
            this.photoList[item.type] = {
              type: item.type,
              photoId: '0',
              photoPath: item.photoPath
            }
            this.photoFileGet(item)
          }
        } else {
          this.close_loading();
        }
        this.photoListInit = JSON.parse(JSON.stringify(this.photoList))
      }).catch((error) => {
        this.close_loading();
      })

    },

    // 写真file取得
    photoFileGet(item) {
      amsApi.photoFile_get(item).then(res => {
        let blob = new Blob([res], { type: 'image/jpeg' })
        var url = window.URL.createObjectURL(blob)
        if (item.type === "1") {
          this.parkingFeeImageList.push({ url: item.photoPath })
          this.photoGet('parkingFee', url, item)
        } else if (item.type === "2") {
          this.roadFeeImageList.push({ url: item.photoPath })
          this.photoGet('roadFee', url, item)
        } if (item.type === "3") {
          this.othersExpensesImageList.push({ url: item.photoPath })
          this.photoGet('othersExpenses', url, item)
        } if (item.type === "4") {
          this.transportExpensesTripImageList.push({ url: item.photoPath })
          this.photoGet('transportExpensesTrip', url, item)
        } if (item.type === "5") {
          this.accommodationImageList.push({ url: item.photoPath })
          this.photoGet('accommodation', url, item)
        }

        if (this.srcindex == this.personalPhotoData.length - 1) {
          this.close_loading();
        } else {
          this.srcindex = this.srcindex + 1
        }
      }).catch((error) => {
        this.close_loading();
      })
    },

    // 照片检索前数据初始化
    photoInit() {
      this.personalPhotoData = []
      this.photoList = {}
      this.parkingFeeImageList = []
      this.roadFeeImageList = []
      this.othersExpensesImageList = []
      this.transportExpensesTripImageList = []
      this.accommodationImageList = []
      this.parkingFeeUrl = ''
      this.roadFeeUrl = ''
      this.othersExpensesUrl = ''
      this.transportExpensesTripUrl = ''
      this.accommodationUrl = ''
    },

    // 照片数据赋值
    photoGet(itemName, url, item) {
      var urlsLength = this[itemName + 'ImageList'].length
      var oneImage = {}
      oneImage.name = 'test.jpeg'
      oneImage.url = url
      this[itemName + 'Url'] = item.photoPath
      this[itemName + 'ImageList'] = []
      this[itemName + 'ImageList'].splice(urlsLength, 0, oneImage)
    },

    // 退出登录处理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: 'true'
        }).then(() => {
          var vm = this
          vm.$router.push({ path: url.routerUrl_K0006 })
        }).catch(() => {
        })
      } else {
        var vm = this
        vm.$router.push({ path: url.routerUrl_K0006 })
      }
    },
    // res_code処理
    res_code_back(res) {
      if (res.code === 202) {
        this.changeFgl = false
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
        this.query()
      } else if (res.code === 308) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'textCenter'
          }).then(() => {
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0006 })
          }).catch(() => {
            this.close_loading()
          })
        }, 500)
      } else if (res.code === 408) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            customClass: 'textCenter'
          }).then(() => {
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0006 })
          }).catch(() => {
            this.close_loading()
          })
        }, 500)
        //add by hexy 20200921 start 
      } else if (res.code === 428) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: 'true'
          }).then(() => {
            // はい
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0006 })
          }).catch(() => {
            // いいえ
            this.close_loading()
          })
        }, 500)
        //add by hexy 20200921 end 
      } else if (res.code === 400) {
        var reg1 = '{0}'
        var reg2 = '{1}'
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut)
        this.$message.error({ message: msg, showClose: true }) // 更新失敗
        this.close_loading()
      } else if (res.code === 430) {
        this.$message.error({ message: this.$t('COMMON.MSG_STOREOUT_EXPENSE'), showClose: true }) // 退店が押下されていなければ保存できません。 
        this.close_loading()
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
        this.close_loading()
      }
    },
    //检索按钮事件（交通费自动计算）
    async transport_search_click(){
      //別現場より移動をチェックして、後ろの現場を選択しない場合、メッセージを表示する
      if(this.initiallyFieldFlag=='1'&&this.isEmpty(this.initiallyFieldCd)){
        this.$message.error({ message: this.$t('COMMON.MSG_EXPENSE_CHECK13'), showClose: true })
        return
      }
      //直接入力欄削除
      if(!this.isEmpty_zero(this.trainBus)||!this.isEmpty_zero(this.km)){
        let res = await this.$confirm_hint(this.$t('COMMON.MSG_EXPENSE_CHECK12'))
        console.log(res)
        if(res){
          this.km='0.0'
          this.kmPrice='0'
          this.trainBus='0'
        }else{
          return
        }
      }
      this.set_loading()
      //交通费自动计算
      //電車・バス 交通费
      if(this.transportFlag=='1'){   
        //駅(自宅)
        var station_home=!this.isEmpty(this.nearestStationBusP)?this.nearestStationBusP:(!this.isEmpty(this.nearestStationP)?this.nearestStationP:'')
        //駅(店舗)
        var station_store=!this.isEmpty(this.nearestStationBusS)?this.nearestStationBusS:(!this.isEmpty(this.nearestStationS)?this.nearestStationS:'')
        //別現場駅(店舗)
        var initiallyStation_store=!this.isEmpty(this.initiallyFieldNearestStationBusS)?this.initiallyFieldNearestStationBusS:(!this.isEmpty(this.initiallyFieldNearestStationS)?this.initiallyFieldNearestStationS:'')
        //计算用参数
        var param={
          jobDate:this.job_date,
          stationFrom:'',
          stationTo:'',
        }
        //作業終了後帰宅、「別現場より移動」にチェックしない場合：自宅 - 当現場＋当現場 - 自宅の交通費
        if(this.otherFieldFlag=='0'&&this.initiallyFieldFlag=='0'){
          //自宅 - 当現場
          if(!this.isEmpty(station_home)&&!this.isEmpty(station_store)){
            param.stationFrom = station_home
            param.stationTo = station_store                                                                                                                            
            var calResult1 = await this.transport_calculation_eki(param)
            if(calResult1.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          //当現場 - 自宅
          if(!this.isEmpty(station_home)&&!this.isEmpty(station_store)){
            param.stationFrom = station_store
            param.stationTo = station_home
            var calResult2 = await this.transport_calculation_eki(param)
            if(calResult2.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          if(!this.isEmpty(calResult1.cheapRoute)&&!this.isEmpty(calResult2.cheapRoute)){
            this.route=calResult1.cheapRoute+'\n'+calResult2.cheapRoute
          }else{
            this.route=calResult1.cheapRoute+calResult2.cheapRoute
          }
          this.trainBusAuto=utilsApi.decimalFormatter((calResult1.cheapCost+calResult2.cheapCost).toString())
        }
        //作業終了後帰宅、「別現場より移動」にチェックする場合：移動元現場 - 当現場 + 当現場 - 自宅の交通費
        if(this.otherFieldFlag=='0'&&this.initiallyFieldFlag=='1'){
          //移動元現場 - 当現場
          if(!this.isEmpty(initiallyStation_store)&&!this.isEmpty(station_store)){
            param.stationFrom = initiallyStation_store
            param.stationTo = station_store                                                                                                                            
            var calResult1 = await this.transport_calculation_eki(param)
            if(calResult1.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          //当現場 - 自宅
          if(!this.isEmpty(station_home)&&!this.isEmpty(station_store)){
            param.stationFrom = station_store
            param.stationTo = station_home
            var calResult2 = await this.transport_calculation_eki(param)
            if(calResult2.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          if(!this.isEmpty(calResult1.cheapRoute)&&!this.isEmpty(calResult2.cheapRoute)){
            this.route=calResult1.cheapRoute+'\n'+calResult2.cheapRoute
          }else{
            this.route=calResult1.cheapRoute+calResult2.cheapRoute
          }
          
          this.trainBusAuto=utilsApi.decimalFormatter((calResult1.cheapCost+calResult2.cheapCost).toString())
        }
        //帰宅せず別現場へ、「別現場より移動」にチェックしない場合：自宅 - 当現場の交通費
        if(this.otherFieldFlag=='1'&&this.initiallyFieldFlag=='0'){
          //自宅 - 当現場
          if(!this.isEmpty(station_home)&&!this.isEmpty(station_store)){
            param.stationFrom = station_home
            param.stationTo = station_store                                                                                                                          
            var calResult1 = await this.transport_calculation_eki(param)
            if(calResult1.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          this.route=calResult1.cheapRoute
          this.trainBusAuto=utilsApi.decimalFormatter(calResult1.cheapCost.toString())
        }
        //帰宅せず別現場へ、「別現場より移動」にチェックした場合：移動元現場 - 当現場の交通費
        if(this.otherFieldFlag=='1'&&this.initiallyFieldFlag=='1'){
          //移動元現場 - 当現場
          if(!this.isEmpty(initiallyStation_store)&&!this.isEmpty(station_store)){
            param.stationFrom = initiallyStation_store
            param.stationTo = station_store                                                                                                                           
            var calResult1 = await this.transport_calculation_eki(param)
            if(calResult1.successFlg==false){
              this.close_loading();
              return
            }
          }else{
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })          
            return
          }
          this.route=calResult1.cheapRoute
          this.trainBusAuto=utilsApi.decimalFormatter(calResult1.cheapCost.toString())
        }
        this.kmAuto='0.0'
        this.kmPriceAuto='0'   
        this.close_loading();              
      }//end  電車・バス 交通费
      //マイカー交通费
      if(this.transportFlag=='2'){
        var calkm1=0
        var calkm2=0
        //緯経度(自宅)
        var location_home=this.geoLocationLatP+','+this.geoLocationLngP
        //緯経度(店舗)
        var location_store=this.geoLocationLatS+','+this.geoLocationLngS
        //緯度,経度(移動元現場店舗)
        var lat_initiallystore=this.initiallyFieldGeoLocationLatS+','+this.initiallyFieldGeoLocationLngS
        //计算用参数
        var param={
          origin:'',
          destination:'',
        }
        //car 作業終了後帰宅、「別現場より移動」にチェックしない場合：自宅 - 当現場＋当現場 - 自宅の交通費
        if(this.otherFieldFlag=='0'&&this.initiallyFieldFlag=='0'){
           //自宅 - 当現場
          if(this.isEmpty(this.geoLocationLatP)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=location_home
            param.destination=location_store
            var retObj = await this.transport_calculation_google(param)
            console.log('retObj1')
            console.log(retObj)
            if(retObj.successFlg){
              calkm1 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
            
          }
          //当現場 - 自宅
          if(this.isEmpty(this.geoLocationLatP)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=location_store
            param.destination=location_home
            var retObj = await this.transport_calculation_google(param)
                        console.log('retObj2')
            console.log(retObj)
            if(retObj.successFlg){
              calkm2 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
          }
          this.kmAuto=utilsApi.decimalFormatter((calkm1+calkm2).toFixed(1))
          this.kmPriceAuto=utilsApi.decimalFormatter(utilsApi.tofixeds((Number(calkm1+calkm2)*Number(this.transportTeate)),0))
        }
        //car 作業終了後帰宅、「別現場より移動」にチェックする場合：移動元現場 - 当現場 + 当現場 - 自宅の交通費
        if(this.otherFieldFlag=='0'&&this.initiallyFieldFlag=='1'){
           //移動元現場 - 当現場
          if(this.isEmpty(this.initiallyFieldGeoLocationLatS)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=lat_initiallystore
            param.destination=location_store
            var retObj =  await this.transport_calculation_google(param)
            if(retObj.successFlg){
              calkm1 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
          }
          //当現場 - 自宅
          if(this.isEmpty(this.geoLocationLatP)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=location_store
            param.destination=location_home
            var retObj = await this.transport_calculation_google(param)
            if(retObj.successFlg){
              calkm2 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
          }
          this.kmAuto=utilsApi.decimalFormatter((calkm1+calkm2).toFixed(1))
          this.kmPriceAuto=utilsApi.decimalFormatter(utilsApi.tofixeds((Number(calkm1+calkm2)*Number(this.transportTeate)),0))
        }
        //帰宅せず別現場へ、「別現場より移動」にチェックしない場合：自宅 - 当現場の交通費
        if(this.otherFieldFlag=='1'&&this.initiallyFieldFlag=='0'){
          //自宅 - 当現場
          if(this.isEmpty(this.geoLocationLatP)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=location_home
            param.destination=location_store
            var retObj = await this.transport_calculation_google(param)

            if(retObj.successFlg){
              calkm1 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
          }
          this.kmAuto=utilsApi.decimalFormatter((calkm1).toString())
          this.kmPriceAuto=utilsApi.decimalFormatter(utilsApi.tofixeds(((calkm1)*Number(this.transportTeate)),0))
        }
        //帰宅せず別現場へ、「別現場より移動」にチェックした場合：移動元現場 - 当現場の交通費
        if(this.otherFieldFlag=='1'&&this.initiallyFieldFlag=='1'){
          //移動元現場 - 当現場
          if(this.isEmpty(this.initiallyFieldGeoLocationLatS)||this.isEmpty(this.geoLocationLatS)){
            this.close_loading();
            this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })          
            return
          }else{
            param.origin=lat_initiallystore
            param.destination=location_store
            retObj = await this.transport_calculation_google(param)
            if(retObj.successFlg){
              calkm1 =retObj.calkm
            }else{
              this.close_loading();
              this.$message.error({ message: this.$t('COMMON.MSG_ZERO_RESULTS'), showClose: true })
              return
            }
          }
          this.kmAuto=utilsApi.decimalFormatter((calkm1).toString())
          this.kmPriceAuto=utilsApi.decimalFormatter(utilsApi.tofixeds(((calkm1)*Number(this.transportTeate)),0))
        }
        this.trainBusAuto='0'
        this.route=''
      }
      console.log('end transport_search_click') 
      //自动计算交通费的初始状态保存(只保存时check使用)
      this.transport_status_copy.otherFieldFlag=this.otherFieldFlag
      this.transport_status_copy.initiallyFieldFlag=this.initiallyFieldFlag
      this.transport_status_copy.transportFlag=this.transportFlag
      this.transport_status_copy.initiallyFieldCd=this.initiallyFieldCd
      this.close_loading();
    },
    // 保存按钮事件
    save_click() {
      // 実費計、合計の計算
      this.calculateExpenses()

      // チェック処理
      if (!this.saveCheck()) {
        return
      }
      //別現場より移動チェック
      if(this.initiallyFieldFlag=='1'&&this.isEmpty(this.initiallyFieldCd)){
        this.$message.error({ message: this.$t('COMMON.MSG_EXPENSE_CHECK13'), showClose: true })
        return
      }
      // 下記の経費項目は金額入力あり・領収書添付なしがある場合、メッセージを表示する。
      if (this.itemPhotoCheck()) {
        this.$message.error({ message: this.$t('COMMON.MSG_PHOTO_CHECK'), showClose: true })
        return
      }
      //自动计算交通费的初始状态check
      if(this.transportFlag!='4'&&this.transportFlag!='3'){
        if(this.transport_status_copy.otherFieldFlag!=this.otherFieldFlag||
          this.transport_status_copy.initiallyFieldFlag!=this.initiallyFieldFlag||
          this.transport_status_copy.transportFlag!=this.transportFlag||
          this.transport_status_copy.initiallyFieldCd!=this.initiallyFieldCd){
            this.$message.error({ message: this.$t('COMMON.MSG_EXPENSE_CHECK14'), showClose: true })
            return
        }
      }
      // 実費計
      var msgs = []
      var msg1 = validatorApi.expensesInputCheck('actualCostTotal', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL'))
      var msg2 = validatorApi.expensesInputCheck('total', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TOTAL'))
      if (msg1.length > 0) {
        msgs.push('・' + msg1[0])
      }
      if (msg2.length > 0) {
        msgs.push('・' + msg2[0])
      }
      if (msgs.length > 0) {
        //check确认提示
        var msg = ''
        if (msgs.length > 1) {
          for (var item of msgs) {
            msg = msg + '<span>' + item + '</span><br/>'
          }
        } else {
          msg = '<span>' + msgs[0] + '</span><br/>'
        }
        // 下記の警告を確認してください。
        this.$confirm(msg, this.$t('COMMON.MSG_CONFIRM_WARNING'), {
          confirmButtonText: this.$t('COMMON.BTN_REGIST'),//BTN_REGIST
          cancelButtonText: this.$t('COMMON.BTN_CHANGE'),//修正
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "btn-custom-cancel_k0007",
          confirmButtonClass: "btn-custom-confirm_k0007",
          type: 'warning',
          center: true,
          showClose: false,
          customClass: 'confirmStyle',
        }).then(() => {
          // 継続の場合、保存処理
          this.photoAndExpensesCheck()
        }).catch(() => {
          // 確認の場合、取消         
        });
      } else {
        this.photoAndExpensesCheck()
      }
    },

    //  経費と写真の関連チェック
    photoAndExpensesCheck() {
      this.photoItemSet()
      if (this.photoItemCheck()) {
        // 保存処理
        const newDatas = []
        const h = this.$createElement
        // 経費項目は空白或いは「0」のため、撮影完了できません。当該写真を削除しても、よろしいでしょうか
        newDatas.push(h('p', { style: 'text-align:left' }, this.$t('COMMON.MSG_PERSONAL_PHOTO')))
        this.$confirm(
          h('div', null, newDatas), '', {
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//いいえ
          center: true,
          showClose: false,
          customClass: 'confirmStyle',
          type: 'warning'
        }).then(() => {
          // 保存时先进行图片上传，成功之后进行数据更新
          this.saveConfirm()
        }).catch(() => {
          // 確認の場合、取消         
        });
        return
      } else {
        this.saveConfirm()
      }
    },

    // 保存确认提示
    saveConfirm() {
      // 保存処理
      this.$confirm(this.$t('COMMON.MSG_SAVE'), {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: 'true'
      }).then(() => {
        //实现Loading 加载方法
        this.set_loading()
        // 保存时先进行图片上传，成功之后进行数据更新
        this.photoSave()
      }).catch(() => {
        // 取消
      })
    },

    //数据更新
    paramDataSave() {
      var update_params = {}
      update_params.crewCd = this.crewCd
      update_params.userCd = this.userCd
      update_params.storePositionCd = this.storePositionCd
      update_params.storePositionCdNew = this.storePositionCd

      update_params.parkingFee = utilsApi.strToNum(this.parkingFee)
      update_params.roadFee = utilsApi.strToNum(this.roadFee)
      update_params.moveAllowance = utilsApi.strToNum(this.moveAllowance)
      update_params.driverAllowance = utilsApi.strToNum(this.driverAllowance)
      update_params.othersExpenses = utilsApi.strToNum(this.othersExpenses)
      update_params.transportExpensesTrip = utilsApi.strToNum(this.transportExpensesTrip)
      update_params.accommodation = utilsApi.strToNum(this.accommodation)
      update_params.allowanceTrip = utilsApi.strToNum(this.allowanceTrip)
      update_params.tripAllowanceManager = utilsApi.strToNum(this.tripAllowanceManager)
      update_params.actualCostTotal = utilsApi.strToNum(this.actualCostTotal)
      update_params.total = utilsApi.strToNum(this.total)
      update_params.sign = ''
      update_params.jobState = this.jobState
      update_params.selfFlag = 1
      update_params.updateDate = this.updateDate
      update_params.trminal = 'staff'
      update_params.gamenId = 'SK_0007'
      update_params.photoItem = []
      update_params.delPhotoUrl = ''//写真パス(削除用)
      update_params.div = '2'
      if(!this.isEmpty_zero(this.trainBus)||!this.isEmpty_zero(this.km)){//有手动的情况下，手段强制为手动入力
        this.transportFlag='3'
      }
      update_params.transportFlag = this.transportFlag
      if(this.isEmpty(this.transportFlag)||this.transportFlag=='3'){
        update_params.trainBus = utilsApi.strToNum(this.trainBus)
        update_params.km = utilsApi.strToNum(this.km)
        update_params.kmPrice = utilsApi.strToNum(this.kmPrice)
        update_params.route = ''
        update_params.otherFieldFlag = '99'
        update_params.initiallyFieldFlag = '0'
        update_params.initiallyFieldCd =''
      }else{
        update_params.trainBus = utilsApi.strToNum(this.trainBusAuto)
        update_params.km = utilsApi.strToNum(this.kmAuto)
        update_params.kmPrice = utilsApi.strToNum(this.kmPriceAuto)
        update_params.route = this.route
        update_params.otherFieldFlag = this.otherFieldFlag
        update_params.initiallyFieldFlag = this.initiallyFieldFlag
        update_params.initiallyFieldCd = this.initiallyFieldCd
      }

      var that = this

      // 写真变更参数
      var that = this
      Object.keys(this.photoItem).forEach(function (key) {
        if (that.photoItem[key].photoId == '' || (that.photoList[key] && that.photoList[key].files)) {
          update_params.photoItem.push(that.photoItem[key])
          // 	経費写真がある　且つ　経費写真が変更された場合
          // 写真パス(削除用)：初期で取得した写真パス*複数写真の場合、「,」で区切り										
          if (that.photoListInit[key]) {
            if (update_params.delPhotoUrl) {
              update_params.delPhotoUrl = update_params.delPhotoUrl + ',' + that.photoListInit[key].photoPath
            } else {
              update_params.delPhotoUrl = that.photoListInit[key].photoPath
            }
          }

          /**
           * 	駐車代チェック：駐車代写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  有料道路代チェック：有料道路代写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  消耗・通信・破損・運搬チェック：消耗・通信・破損・運搬写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  公共移動(出張)チェック：公共移動(出張)写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           *  宿泊費チェック：宿泊費写真が変更された場合（削除、変更など）、0にする。以外は更新しない
           */
          update_params[that.expensesCheck(key)] = 0
        }
      })
      amsApi.k_0007_update([update_params]).then(res => {
        this.res_code_back(res)
      }).catch((err) => {
        this.close_loading()
      });
    },

    // 照片参数设定
    photoItemSet() {
      var photoId = []
      var items = {}
      var that = this
      // 确定itemName
      for (var i = 1; i <= 5; i++) {
        switch (i) {
          case 1:
            var itemName = 'parkingFee'
            break;
          case 2:
            var itemName = 'roadFee'
            break;
          case 3:
            var itemName = 'othersExpenses'
            break;
          case 4:
            var itemName = 'transportExpensesTrip'
            break;
          case 5:
            var itemName = 'accommodation'
            break;
        }

        // 遍历检索出来的照片
        for (var item of this.personalPhotoData) {
          photoId.push(item.type)
          items[item.type] = item
        }

        // 检索有照片，photoItem赋值图片参数，没有赋空
        if (photoId.indexOf(i + '') == -1) {
          this.photoItem[i] = {
            photoId: '',
            photoPath: '',
            type: i + '',
          }
        } else if (this[itemName] === '0') {
          this.photoItem[i] = {
            photoId: items[i].photoId,
            photoPath: items[i].photoPath,
            type: items[i].type,
          }
        }
        // 新插入的图片photoItem参数绑定
        Object.keys(this.photoList).forEach(function (key) {
          if (key == i) {
            if (that.photoList[key] === '' || that[itemName] === '0') {
              that.photoItem[key].photoId = ''
              that.photoItem[key].photoPath = ''
              that.photoItem[key].type = i + ''
            } else {
              that.photoItem[key].photoId = that.photoList[key].photoId
              that.photoItem[key].photoPath = that.photoList[key].photoPath
              that.photoItem[key].type = that.photoList[key].type
            }
          }
        })
      }
    },

    // 下記の経費項目は金額入力あり・領収書添付なしがある場合、メッセージを表示する。
    itemPhotoCheck() {
      if (utilsApi.strToNum(this.parkingFee) && utilsApi.strToNum(this.parkingFee) != 0 && !this.photoList['1']) {
        return true
      } else if (utilsApi.strToNum(this.roadFee) && utilsApi.strToNum(this.roadFee) != 0 && !this.photoList['2']) {
        return true
      } else if (utilsApi.strToNum(this.othersExpenses) && utilsApi.strToNum(this.othersExpenses) != 0 && !this.photoList['3']) {
        return true
      } else if (utilsApi.strToNum(this.transportExpensesTrip) && utilsApi.strToNum(this.transportExpensesTrip) != 0 && !this.photoList['4']) {
        return true
      } else if (utilsApi.strToNum(this.accommodation) && utilsApi.strToNum(this.accommodation) != 0 && !this.photoList['5']) {
        return true
      }
      return false
    },

    // 下記の経費項目は空白或いは「０」、写真がある場合、メッセージを表示する。																						
    //駐車代、有料道路代、消耗・通信・破損・運搬、公共移動(出張)、宿泊費																							
    photoItemCheck() {
      if (this.photoList['1'] && this.photoList['1'].photoId !== '' && utilsApi.strToNum(this.parkingFee) == 0) {
        return true
      } else if (this.photoList['2'] && this.photoList['2'].photoId !== '' && utilsApi.strToNum(this.roadFee) == 0) {
        return true
      } else if (this.photoList['3'] && this.photoList['3'].photoId !== '' && utilsApi.strToNum(this.othersExpenses) == 0) {
        return true
      } else if (this.photoList['4'] && this.photoList['4'].photoId !== '' && utilsApi.strToNum(this.transportExpensesTrip) == 0) {
        return true
      } else if (this.photoList['5'] && this.photoList['5'].photoId !== '' && utilsApi.strToNum(this.accommodation) == 0) {
        return true
      }
      return false
    },
    //移動手段変更イベント
    transportFlagChange(val){
      
        this.otherFieldFlag='0'
        this.initiallyFieldFlag='0'
        this.initiallyFieldCd=''
        this.kmAuto='0.0'
        this.trainBusAuto='0'
        this.kmPriceAuto='0'
        this.route=''
    
    },
    //別現場より移動 変更イベント
    initiallyFieldChange(val){
      if(val=='0'){
        this.initiallyFieldCd=''
      }
    },
    // 経費チェック
    expensesCheck(key) {
      var itemName = '';
      switch (key) {
        case '1':
          itemName = 'parkingFeeCheck'//駐車代チェック
          break;
        case '2':
          itemName = 'roadFeeCheck'//有料道路代チェック
          break;
        case '3':
          itemName = 'othersExpensesCheck'//消耗・通信・破損・運搬チェック
          break;
        case '4':
          itemName = 'transportExpensesTripCheck'//公共移動(出張)チェック
          break;
        case '5':
          itemName = 'accommodationCheck'//宿泊費チェック
          break;
      }
      return itemName
    },

    //图片保存
    photoSave() {
      this.photoFormData = new FormData()
      var that = this
      var photoSum = 0

      Object.keys(this.photoList).forEach(function (key) {
        if (that.photoList[key] && that.photoList[key].files) {
          photoSum = photoSum + 1
          that.photoFormData.append('files', that.photoList[key].files, that.photoList[key].photoPath)
        }
      })

      if (photoSum != 0) {
        amsApi.k_0007_saveImage(this.photoFormData).then(res => {
          if (res.code == 205) {
            this.paramDataSave()
          } else if (res.code == 311) {
            //图片上传失败
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            this.close_loading()
          }
        })
      } else {
        this.paramDataSave()
      }
    },

    //保存check
    saveCheck() {
      var msg = ''
      this.tablDataExpenses()
      // 電車・バス
      msg = validatorApi.expenseDigitsCheck('trainBus', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRAINBUS'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 移動km
      msg = validatorApi.expenseDigitsCheck('km', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_KMPRICE'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 駐車代
      msg = validatorApi.expenseDigitsCheck('parkingFee', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_PARKINGFEE'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 有料道路代
      msg = validatorApi.expenseDigitsCheck('roadFee', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ROADFEE'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 移動手当
      msg = validatorApi.expenseDigitsCheck('moveAllowance', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_MOVEALLOWANCE'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 移動・移動運転手当
      msg = validatorApi.expenseDigitsCheck('driverAllowance', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_DRIVERALLOWANCE'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 消耗・通信・破損・運搬
      msg = validatorApi.expenseDigitsCheck('othersExpenses', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_OTHERSEXPENSES'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 公共移動(出張)
      msg = validatorApi.expenseDigitsCheck('transportExpensesTrip', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRANSPORTEXPENSESTRIP'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 宿泊費
      msg = validatorApi.expenseDigitsCheck('accommodation', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACCOMMODATION'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      //食事補助 
      msg = validatorApi.expenseDigitsCheck('allowanceTrip', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ALLOWANCETRIP'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 出張手当(管理職以上)
      msg = validatorApi.expenseDigitsCheck('tripAllowanceManager', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TRIPALLOWANCEMANAGER'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 実費計
      msg = validatorApi.expenseDigitsCheck('actualCostTotal', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_ACTUALCOSTTOTAL'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      // 合計
      msg = validatorApi.expenseDigitsCheck('total', this, this.queryParam[0], this.$t('MODULE.K0007_LBL_TOTAL'))
      if (msg !== '') {
        this.$message.error({ message: msg, showClose: true })
        return
      }
      return true
    },

    // 実費計、合計の計算について、計算結果を実費計、合計に設定する
    calculateExpenses() {
      //実費計 =  電車バス(直接入力) + ガソリン精算 (直接入力) + 駐車代 + 有料道路代 + 消耗・通信・破損・運搬 + 公共移動（出張） 
      //          + 宿泊費 +  電車バス(自動計算) + ガソリン精算 (自動計算) 
      var actualCostTotal = (utilsApi.strToNum(this.trainBus)
        + utilsApi.strToNum(this.kmPrice)
        + utilsApi.strToNum(this.parkingFee)
        + utilsApi.strToNum(this.roadFee)
        + utilsApi.strToNum(this.othersExpenses)
        + utilsApi.strToNum(this.transportExpensesTrip)
        + utilsApi.strToNum(this.accommodation)
        + utilsApi.strToNum(this.trainBusAuto)
        + utilsApi.strToNum(this.kmPriceAuto)).toString()
      if (isNaN(actualCostTotal)) {
        this.actualCostTotal = '0'
      } else {
        this.actualCostTotal = utilsApi.decimalFormatter(actualCostTotal)
      }
      //合計 = 電車バス(直接入力) + ガソリン精算 (直接入力) + 駐車代 + 有料道路代 + 移動手当 + 移動運転手当 
      //      + 消耗・通信・破損・運搬 + 公共移動（出張） + 宿泊費 + 食事補助 + 出張手当 + 電車バス(自動計算) + ガソリン精算 (自動計算) 
      var total = (utilsApi.strToNum(this.trainBus)
        + utilsApi.strToNum(this.kmPrice)
        + utilsApi.strToNum(this.parkingFee)
        + utilsApi.strToNum(this.roadFee)
        + utilsApi.strToNum(this.moveAllowance)
        + utilsApi.strToNum(this.driverAllowance)
        + utilsApi.strToNum(this.othersExpenses)
        + utilsApi.strToNum(this.transportExpensesTrip)
        + utilsApi.strToNum(this.accommodation)
        + utilsApi.strToNum(this.allowanceTrip)
        + utilsApi.strToNum(this.tripAllowanceManager)
        + utilsApi.strToNum(this.trainBusAuto)
        + utilsApi.strToNum(this.kmPriceAuto)).toString();
      if (isNaN(total)) {
        this.total = '0'
      } else {
        this.total = utilsApi.decimalFormatter(total)
      }

    },

    //时间比较
    compareDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      date1.setDate(date1.getDate() + 1);
      date2.setDate(date2.getDate());
      var month1 = date1.getMonth() + 1;
      var month2 = date2.getMonth() + 1;
      var day1 = date1.getDate();
      var day2 = date2.getDate();
      var d1 = date1.getFullYear() + '/' + this.getFormatDate(month1) + '/' + this.getFormatDate(day1);
      var d2 = date2.getFullYear() + '/' + this.getFormatDate(month2) + '/' + this.getFormatDate(day2);
      var time1 = parseInt(Date.parse(new Date(d1)) / 1000 / 3600 / 24);
      var time2 = parseInt(Date.parse(new Date(d2)) / 1000 / 3600 / 24);
      var nDays = time2 <= time1;
      return nDays;
    },
    //时间格式化
    getFormatDate(arg) {
      if (arg == undefined || arg == '') {
        return '';
      }
      var re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    },

    // 经费选择
    expensesChange(expenses, itemName, fieldName) {
      this.changeFgl = true
      this[itemName] = utilsApi.decimalFormatter(expenses)
      this.tablDataExpenses()
      // 入力された経費の正確性のチェック
      var msgs = validatorApi.expensesInputCheck(itemName, this, this.queryParam[0], fieldName)
      if (msgs.length > 0) {
        //确认提示
        this.confirmAlert(msgs)
      }
    },

    // 经费输入框离开焦点
    async blurInput(expenses, itemName, fieldName) {

      this[itemName] = utilsApi.decimalFormatter(expenses)
      if (itemName === 'km'||itemName === 'trainBus') {
        if(this.transportFlag!='3'){//移動手段： 「3:直接入力」以外の場合
          this.tablDataExpenses()
          // 入力された経費の正確性のチェック
          var msgs = validatorApi.expensesInputCheck(itemName, this, this.queryParam[0], fieldName)
          if (msgs.length > 0) {
            console.log(1111)
            //确认提示
            await this.confirmAlert(msgs)
            this.autoDelConfirm(itemName)
          }else{
             console.log(333)
             this.autoDelConfirm(itemName)
          }
        }else{
          if (itemName === 'km'&&this.km !== '') {
            this.kmPrice = utilsApi.decimalFormatter(utilsApi.tofixeds((Number(this.km.replace(/,/g, "")) * Number(this.transportTeate)), 0).toString())
          }
          if (itemName === 'trainBus'&&this.trainBus === '') {
            this.trainBus = '0'
          }
          if (itemName === 'km'&&this.km === '') {
            this.km = '0.0'
            this.kmPrice='0'
          }
          this.tablDataExpenses()
          // 入力された経費の正確性のチェック
          var msgs = validatorApi.expensesInputCheck(itemName, this, this.queryParam[0], fieldName)
          if (msgs.length > 0) {
            console.log(22)
            //确认提示
            this.confirmAlert(msgs)
          }
        }
      } else {
        if (this[itemName] === '') {
          this[itemName] = '0'
        }
        this.tablDataExpenses()
        // 入力された経費の正確性のチェック
        var msgs = validatorApi.expensesInputCheck(itemName, this, this.queryParam[0], fieldName)
        if (msgs.length > 0) {
          console.log(33)
          //确认提示
          this.confirmAlert(msgs)
        }
        
      }
      this.calculateExpenses()
    },

    //经费输入
    inputChange() {
      this.changeFgl = true
    },

    //check确认提示
    confirmAlert(msgs) {
      var msg = ''
      if (msgs.length > 1) {
        for (var item of msgs) {
          msg = msg + '<span>・' + item + '</span><br/>'
        }
      } else {
        msg = '<span>' + msgs[0] + '</span><br/>'
      }
      return new Promise((resolve, reject) => {
        // 下記の警告を確認してください。
        this.$alert(msg, this.$t('COMMON.MSG_CONFIRM_WARNING'), {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true,
          showClose: false,
          customClass: 'confirmStyle',
        }).then(() => {
          resolve(true)
        }).catch(() => {
          resolve(false)
        })
      })
    },

    tablDataExpenses() {
      this.queryParam[0] = {}
      this.queryParam[0].trainBus = this.trainBus//電車・バス
      this.queryParam[0].km = this.km
      this.queryParam[0].kmPrice = this.kmPrice
      this.queryParam[0].parkingFee = this.parkingFee// 駐車代
      this.queryParam[0].roadFee = this.roadFee//有料道路代
      this.queryParam[0].moveAllowance = this.moveAllowance//移動手当
      this.queryParam[0].driverAllowance = this.driverAllowance//移動・移動運転手当
      this.queryParam[0].othersExpenses = this.othersExpenses//消耗・通信・破損・運搬
      this.queryParam[0].transportExpensesTrip = this.transportExpensesTrip// 公共移動(出張)
      this.queryParam[0].accommodation = this.accommodation//宿泊費
      this.queryParam[0].allowanceTrip = this.allowanceTrip//食事補助
      this.queryParam[0].tripAllowanceManager = this.tripAllowanceManager//出張手当(管理職以上)
      this.queryParam[0].actualCostTotal = this.actualCostTotal//実費計
      this.queryParam[0].total = this.total//合计
    },

    //input获取焦点时自动去掉','和':'
    focusInput(row, itemName) {
      if (row != null && row !== '') {
        if (this[itemName] === '0' || this[itemName] === '0.0') {
          this[itemName] = ''
        } else {
          this[itemName] = row.replace(/:|,/g, "")
        }
      }
    },

    //店舗役職-検索
    searchStorePosition() {
      var div = '13,14,15,16,17';
      var page = 'ul'
      amsApi.conditionApi(page, div).then(res => {
        this.allowanceTripList = res.items.allowanceTrip//食事補助
        this.driverAllowanceList = res.items.driverAllowance//移動運転手当
        this.moveAllowanceList = res.items.moveAllowance//移動手当
        this.personalAttendanceExpense = res.items.personalAttendanceExpense//経費チェック
        this.tripAllowanceManagerList = res.items.tripAllowanceManager//出張手当(管理職以上)
      })
    },

    //店舗現場情報-検索
    searchStoreFieldInfo() {
      var param={}
      param.jobDateTo=this.job_date
      var dateJobDate = new Date(this.job_date)
      param.jobDateFrom=utils.timeDefault(dateJobDate.setDate(dateJobDate.getDate()-1))
      param.userId=this.userCd
      param.crewCd = this.crewCd
      amsApi.storeFieldInfo(param).then(res => {
        if(res.code=='204'){
          this.initiallyFieldList = res.items.storeFieldInfo
          //更新的场合，强制检索一次
          if(!this.isEmpty(this.initiallyFieldCd)){
            this.fieldListChange(this.initiallyFieldCd,'initiallyFieldCd')
          }          
        }
      })
    },
    // 照片删除
    parkingFeePhotoDelete() {
      this.photoDelete('parkingFee', '1')
    },
    roadFeePhotoDelete() {
      this.photoDelete('roadFee', '2')
    },
    othersExpensesPhotoDelete() {
      this.photoDelete('othersExpenses', '3')
    },
    transportExpensesTripPhotoDelete() {
      this.photoDelete('transportExpensesTrip', '4')
    },
    accommodationPhotoDelete() {
      this.photoDelete('accommodation', '5')
    },

    // 删除确认
    photoDelete(itemName, type) {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), {
        confirmButtonText: this.$t('COMMON.BTN_CONFIRM'), // 確認
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: 'true'
      }).then(() => {
        //组件表示图片清空
        this.$refs[itemName].clearFiles()
        //上传用list清空
        this[itemName + 'ImageList'] = []
        this[itemName + 'Url'] = ''
        this[itemName + 'Dialog'] = false
        this.photoList[type] = ''
      }).catch(() => {
      })
    },
    //空判断，不带0
    isEmpty(value){
      if(typeof value=="undefined"||value==null||value==''){
        return true
      }else{
        return false
      }
    },
    //空判断，带0
    isEmpty_zero(value){
      if(typeof value=="undefined"||value==null||value==''||value=='0'||value=='0.0'){
        return true
      }else{
        return false
      }
    },
    //移動手段的制御
    disableTransportFlag(){
      if(this.isEmpty(this.transportFlag)||this.transportFlag=='3'||this.transportFlag=='4'){
        return true
      }else{
        return false
      }
    },
    //交通费计算api(google)
    transport_calculation_google(param){
      var retObj={}
      retObj.successFlg=false
      retObj.calkm=0
      return new Promise(resolve => {
        amsApi.requestGoogleGet(param).then(res => {
          console.log(res)
          if(res.code=='640'){
            retObj.successFlg=false
            resolve(retObj)
          }else{
            retObj.successFlg=true
            retObj.calkm=Number(res.items.distance)
            resolve(retObj)
          }

        }).catch((err) => {
          console.log('google Api Error: '+err)//计算出错
          retObj.successFlg=false
          resolve(retObj)
        });
      }).catch((err) => {
          console.log('google Api Error: '+err)//计算出错
          retObj.successFlg=false
          resolve(retObj)
        });
    },
    //交通费计算api(ekispert)
    transport_calculation_eki(param){
      console.log('transport_calculation_eki start')
      var retObj={}
      retObj.successFlg=false
      retObj.cheapRoute=''
      retObj.cheapCost=0
      return new Promise(resolve => {
        amsApi.requestEkiStationGet(param).then(res => {
          if(res.code=='204'){//正常返回
            retObj.successFlg=true
            retObj.cheapRoute=res.items.route
            console.log(res.items)
            console.log(res.items.route)
            console.log('res.items.route')
            retObj.cheapCost=Number(res.items.trainBus) 
          }else if(res.code=='641'){
            if(retObj.cheapCost==0){
              this.$message.error({ message: this.$t('COMMON.MSG_EXPCGI_ERROR'), showClose: true })
            }
            console.log('ekispert Api Error1: '+err)//计算出错
            retObj.successFlg=false
          }else{
            console.log('ekispert Api Error2: '+err)//计算出错
            retObj.successFlg=false
          }
          resolve(retObj)
        }).catch((err) => {
          console.log('ekispert Api Error3: '+err)//计算出错
          resolve(retObj)
        });
      });
    },
    // 現場名list选择
    fieldListChange(initiallyFieldCd, itemName) {
      var retIndex= this.initiallyFieldList.findIndex(item=>{
        if(item.fieldCd==initiallyFieldCd){
          return true
        }
      })
      if(retIndex!=-1){
        this.initiallyFieldName =this.initiallyFieldList[retIndex].fieldName
        this.initiallyFieldGeoLocationLatS=this.initiallyFieldList[retIndex].geoLocationLatS//別店舗緯度(店) 
        this.initiallyFieldGeoLocationLngS=this.initiallyFieldList[retIndex].geoLocationLngS//別店舗経度(店)
        this.initiallyFieldNearestStationS=this.initiallyFieldList[retIndex].nearestStationS//別店舗最寄り駅(店) 
        this.initiallyFieldNearestStationBusS=this.initiallyFieldList[retIndex].nearestStationBusS//別店舗最寄りバス停(店) 
      }
    },
    //将字符串转为url编码（ekispert用）
    // convertString(queryString){
    //   var unicodeArray= encoding.stringToCode(queryString) 
    //   var sjisArray = encoding.convert(unicodeArray, {to: 'SJIS',from: 'UNICODE',});
    //   var encodedKeyword = encoding.urlEncode(sjisArray);
    //   return encodedKeyword
    // },
    //将交通费字符串转为对象（ekispert用）
    // convertObj(str){
    //   var tempObjEki = {}
    //   var tempEkiArry = str.split('&')
    //   tempEkiArry.forEach((item) => {
    //     var tempsplit = item.split('=')      
    //     tempObjEki[tempsplit[0]]=tempsplit[1]
    //   });
    //   console.log(tempObjEki)
    //   return tempObjEki
    // },
    //最便宜的费用取得（ekispert用）
    // getCheapObj(resObj){
    //   var retObj={
    //     cheapCost:0,
    //     cheapNum:0,
    //     cheapRoute:'',
    //   }
    //   for(var i=1;i<=resObj.val_route_cnt;i++){
    //     if(i==1){
    //       retObj.cheapCost=parseInt(resObj['val_fare_'+i])
    //       retObj.cheapNum=i
    //       retObj.cheapRoute=resObj['val_route_'+i]
    //     }else{
    //       if(retObj.cheapCost>parseInt(resObj['val_fare_'+i])){
    //         retObj.cheapCost=parseInt(resObj['val_fare_'+i])
    //         retObj.cheapNum=i
    //         retObj.cheapRoute=resObj['val_route_'+i]
    //       }
    //     }
    //   }
    //   return retObj
    // },
    //自動計算結果削除的确认提示confirm
    autoDelConfirm(itemName){
      this.$confirm(this.$t('COMMON.MSG_EXPENSE_CHECK11'), {
          confirmButtonText: this.$t('MODULE.K0007_BTN_YES'), // はい
          cancelButtonText: this.$t('MODULE.K0007_BTN_NO'), // キャンセル
          center: 'true'
        }).then(() => {
          this.kmAuto='0.0'
          this.trainBusAuto='0'
          this.kmPriceAuto='0'
          this.transportFlag='3'
          this.otherFieldFlag='99'
          this.initiallyFieldFlag='0'
          this.initiallyFieldCd=''
          this.route=''
          if (itemName === 'km'&&this.km !== '') {
            this.kmPrice = utilsApi.decimalFormatter(utilsApi.tofixeds((Number(this.km.replace(/,/g, "")) * Number(this.transportTeate)), 0).toString())
          }
        }).catch(() => {
          this.km='0.0'
          this.trainBus='0'
          this.kmPrice='0'
        })
    }

  },
  // 初期化自动调用
  created() {
    this.obj = JSON.parse(localStorage.getItem('obj'))
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.storePositionCd = this.obj.storePositionCd
    this.crewCd = this.obj.crewCd
    this.jobState = this.obj.jobStateCd
    this.job_date = this.obj.jobDate
    this.userCd=this.userInfo.userCd
    // 勤怠承認FLAG
    this.approvalFlag = this.obj.approvalFlag
    //add by hexy 20200921 start
    this.transmitFlag = this.obj.transmitFlag
    //add by hexy 20200921 end
    this.searchStorePosition()
   
    // 初期化函数调用
    this.query()

    
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-icon-delete') {
        that.imageLongClick = false;
        that.parkingFeeLongClick = false//是否为图片长按模式（true=长按模式）。
        that.roadFeeLongClick = false//是否为图片长按模式（true=长按模式）。
        that.othersExpensesLongClick = false//是否为图片长按模式（true=长按模式）。
        that.transportExpensesTripLongClick = false//是否为图片长按模式（true=长按模式）。
        that.accommodationLongClick = false//是否为图片长按模式（true=长按模式）。
      }
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        //关闭照片查看器
        that.parkingFeeDialog = false
        that.roadFeeDialog = false
        that.othersExpensesDialog = false
        that.transportExpensesTripDialog = false
        that.accommodationDialog = false
      }
    })
  },
  watch: {
    //経路详细折叠面板控制
    route:function (val) {
      if(this.isEmpty(val)){
        this.activeCollapseName='0'
        //return "1"
      }else{
        this.activeCollapseName='1'
      }
    },
    //駐車代
    parkingFee: function (val) {
      if (val != '' && val !== '0') {
        this.parkingFeeBtn = false
        this.parkingFeeCss = true
      } else {
        this.parkingFeeBtn = true
        this.parkingFeeCss = false
      }
    },
    //有料道路代
    roadFee: function (val) {
      if (val != '' && val !== '0') {
        this.roadFeeBtn = false
        this.roadFeeCss = true
      } else {
        this.roadFeeBtn = true
        this.roadFeeCss = false
      }
    },
    //消耗・通信・破損・運搬
    othersExpenses: function (val) {
      if (val != '' && val !== '0') {
        this.othersExpensesBtn = false
        this.othersExpensesCss = true
      } else {
        this.othersExpensesBtn = true
        this.othersExpensesCss = false
      }
    },
    //公共移動(出張)
    transportExpensesTrip: function (val) {
      if (val != '' && val !== '0') {
        this.transportExpensesTripBtn = false
        this.transportExpensesTripCss = true
      } else {
        this.transportExpensesTripBtn = true
        this.transportExpensesTripCss = false
      }
    },
    //宿泊費
    accommodation: function (val) {
      if (val != '' && val !== '0') {
        this.accommodationBtn = false
        this.accommodationCss = true
      } else {
        this.accommodationBtn = true
        this.accommodationCss = false
      }
    },
  },
}

</script>
<style>
/*panel下全部区域*/
.all_area_k0007 {
  margin-left: 0px;
}
/*检索条件整体样式*/
.span_search_condition_k0007 {
  padding-left: 20px;
  font-size: 10pt;
}
/*下半部入力框内部长度 第一行*/
.textRight .el-input__inner {
  text-align: right;
}
.textLeft .el-input__inner {
  text-align: left;
}
/*按钮样式*/
.Location_k0007 {
  position: relative;
  top: 50%;
  left: 50%;
  height: 30%;
  text-align: center;
  padding: 20px;
}
/*上半部行样式*/
.el-row_k0007 {
  margin-bottom: 10px;
}
/*上半部列样式*/
.el-col_k0007 {
  border-radius: 4px;
  width: 100%;
}

/*下半部span样式*/
.input_span_k0007 {
  padding: 2px 0px 0px 21px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 40%;
}
.input_span2_k0007 {
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 20%;
}
/*下半部span用div样式*/
.div_span_k0007 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 35px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}
/* 经费合计 */
.div_span_k0007_total {
  background-image: linear-gradient(#f7bb77, #eb9546);
  width: 100%;
  height: 35px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}
/*下半部input用div样式*/
.div_input_k0007 {
  width: 100%;
  height: 60px;
  line-height: 0px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}
/*下半部input样式 第一行*/
.input_input1_k0007 {
  width: 40%;
  min-width: 40%;
  padding: 10px 0px 0px 20px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input1_k0007_total {
  width: 80%;
  min-width: 80%;
  padding: 10px 0px 0px 18px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input2_k0007 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input3_k0007 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #918d8d;
  vertical-align: top;
}

.input_input3_k0007 .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #7e7d7d;
}

/*下半部整体div样式*/
.el-detail_k0007 {
  /* overflow-y:auto; */
  width: 100%;
  height: 100%;
}
.el-input__inner {
  line-height: 20px;
}
/* 分割线上下外边距 */
.c0004-divider .el-divider--horizontal {
  margin-top: 8px;
  margin-bottom: 8px;
}
/*只读框字体颜色*/
.c0007_readonly_input .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  -webkit-text-fill-color: rgb(117, 117, 117);
  -webkit-opacity: 1;
  opacity: 1;
}
/*只读框字体颜色1*/
.input_input2_k0007.el-input.is-disabled .el-input__inner,
.input_input3_k0007.el-input.is-disabled .el-input__inner,
.input_input1_k0007.el-input.is-disabled .el-input__inner,
.input_input1_k0007_total.el-input.is-disabled .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243) !important;
  -webkit-text-fill-color: #818181;
  -webkit-opacity: 1;
  opacity: 1;
  z-index: 100;
}
.input_input1_k0007.el-select .el-input.is-disabled .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243) !important;
  -webkit-text-fill-color: rgb(117, 117, 117);
  -webkit-opacity: 1;
  opacity: 1;
}

/*input输入框*/
.css-input-width_k0007 {
  width: 72%;
}
.search-module_k0007 {
  padding-bottom: 10px;
  margin-bottom: 10px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
}
/*面包屑*/
.el-crumb_k0007 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
/*导航*/
.home-content-menu_k0007 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}

.photo_upload .el-upload--picture-card {
  width: 20%;
  height: 43px;
  margin-top: 9px;
  margin-left: 6px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}

/* 图片样式 */
.photo_upload .el-upload-list--picture-card .el-upload-list__item {
  width: 20%;
  height: 43px;
  margin-top: 9px;
  margin-left: 20px;
  margin-right: 0px;
  border: none;
}

/* 图片上传按钮样式 */
.photo_upload .el-upload--picture-card i {
  margin-top: 5px;
  color: #409eff;
}
/* 去除上传图片动画 */
.photo_upload .el-upload-list__item {
  transition: none !important;
}

/* 左边空图片蓝色边框 */
.k0007-photo-border {
  float: left;
  width: 19%;
  height: 40px;
  margin-left: 20px;
  margin-top: 9px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
/* 左边空图片红色边框 */
.parkingFeeCss {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.roadFeeCss {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.othersExpensesCss {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.transportExpensesTripCss {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
/* 左边空图片红色边框 */
.accommodationCss {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
  border: 1px solid red;
  border-radius: 5px;
  margin-top: 9px;
}
.photoNone .el-image__error,
.el-image__placeholder {
  background: none;
  color: #d2eef8;
}

.confirmCss {
  width: 70%;
}
/* 确认提示按钮大小 */
.confirmCss .el-button--small,
.el-button--small.is-round {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
  width: 70px;
}
.confirmCss .el-button--primary {
  border-color: rgb(219, 219, 219);
  background-color: #fff;
  color: #000;
}

.div_input_k0007 .el-icon-circle-close:before {
  color: #fd270a;
}
.textCenter .el-message-box__btns {
  text-align: center;
}

.btn-custom-cancel_k0007 {
  background-color: #409eff !important;
  color: #ffffff !important;
}
.btn-custom-confirm_k0007 {
  border: 1px solid #dcdfe6 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.confirmStyle {
  width: 90%;
}

.confirmStyle .el-message-box__content {
  text-align: left;
}
.div_span_k0007_trasport {
  background-image: linear-gradient(rgb(175, 214, 149), rgb(147, 207, 107));
  width: 100%;
  height: 35px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
  color: #000;
}
.div_radio_k0007_trasport {
  width: 100%;
  height: 30px;
  line-height: 0px;
  background: #d2eef8;
  /* float: left; */
  margin: 0px;
  border: 1px solid #dcdfe6 ;
  padding:20px 0px 10px 20px;
  color: #000;
}
.div_input_k0007_trasport {
  width: 100%;
  height: 60px;
  line-height: 0px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
  color: #000;
}
.input_input1_k0007_trasport {
  width: 40%;
  min-width: 40%;
  padding: 20px 0px 0px 18px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.css-button_green {
	background-image: linear-gradient(#72ae4a,#548235);
  border-color:#9acc79 !important;
	color: #FFFFFF;
	width: 80px;
	font-size: 11pt
}
/*按钮经过样式*/
.div_span_k0007_trasport  .css-btn_green:hover { 
	background-image: linear-gradient(0deg, #72ae4a,#548235 );
  border-color:#9acc79 !important;
}
/*按钮激活和焦点样式*/
.div_span_k0007_trasport  .css-btn_green:active { 
	background-image: linear-gradient(0deg, #72ae4a, #548235);
  border-color:#9acc79 !important;
}
.div_radio_k0007_trasport  .el-radio__input.is-checked + .el-radio__label {
   color:#72ae4a !important;
}
.div_radio_k0007_trasport .el-radio__input.is-checked  .el-radio__inner {
   background:#72ae4a !important;
   background-color:#72ae4a !important;
   border-color:#9acc79 !important;
}
.div_input_k0007 .el-checkbox__input.is-checked+.el-checkbox__label{
  color:#72ae4a !important;
}
.div_input_k0007 .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
     background:#72ae4a !important;
   background-color:#72ae4a !important;
   border-color:#9acc79 !important;
}
.div_radio_k0007_trasport .el-radio{
  color:#000000
}
.K0007_disable_input{
  border-color: rgb(228, 231, 237);
  -webkit-text-fill-color: rgb(117, 117, 117);
  -webkit-opacity: 1;
  opacity: 1;
}
.div_radio_k0007_trasport .el-radio__input.is-disabled+span.el-radio__label {
  color: rgb(117, 117, 117)
}
.div_span_k0007_trasport .el-button--primary.is-disabled,
.div_span_k0007_trasport .el-button--primary.is-disabled:active,
.div_span_k0007_trasport .el-button--primary.is-disabled:focus,
.div_span_k0007_trasport .el-button--primary.is-disabled:hover{
  background-color:#a7c991 !important;
  border-color:#9acc79 !important;
}
.div_span_k0007_trasport .el-button--primary:focus,
.div_span_k0007_trasport .el-button--primary:active,
.div_span_k0007_trasport .el-button--primary:hover{
background-color:#a7c991 !important;
border-color:#9acc79 !important;
 }
.div_span_k0007_trasport .el-button--primary{
  background-color:#a7c991 !important;
  border-color:#9acc79 !important;
 }
.div_input_k0007 .el-checkbox__input.is-disabled+span.el-checkbox__label{
  color:rgb(117, 117, 117)
}

.div_collapse_k0007_trasport .el-collapse-item__header{
  background-image: linear-gradient(rgb(175, 214, 149), rgb(147, 207, 107));
  color:#FFFFFF;
  font-size:10pt;
  padding-left:20px;
  height:30px
}
.div_collapse_k0007_trasport .el-collapse-item__content{
  background: #d2eef8;
}

.multiline {
  display: inline-block;
  white-space: pre-wrap; /* 保留空白符并允许自动换行 */
}
</style>





// WEBPACK FOOTER //
// src/module/page/k_0007.vue